import { render, staticRenderFns } from "./ArtistNavbar.vue?vue&type=template&id=1ca66bf6&"
import script from "./ArtistNavbar.vue?vue&type=script&lang=js&"
export * from "./ArtistNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports